import React from 'react';
import { useNotification } from '../contexts/NotificationContext';
import './GlobalNotification.css';

const GlobalNotification = () => {
  const { notification, hideNotification } = useNotification();

  if (!notification) return null;

  return (
    <div className={`global-notification ${notification.type}`}>
      <div className="notification-content">
        <span className="notification-message">{notification.message}</span>
        {(notification.type === 'success' || notification.type === 'failed') && (
          <button 
            className="notification-close"
            onClick={hideNotification}
            aria-label="Close notification"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default GlobalNotification;
